// extracted by mini-css-extract-plugin
export default {"tick_container":"Tick_tick_container__jUV85"};